import { addEvent, removeEvent, triggerEvent } from '../utils/events';

require('custom-event-polyfill');

export class Modal {

  /**
   * @param  {Dom}    modelContents     contents of the modal to show
   * @param  {Dom}    clickRegion  button or other element to show modal
   */
  constructor(modelContents, clickRegion) {
    this.modalContents = modelContents;
    this.clickRegion = clickRegion;
    this.isOpen = false;
    this.magicNumberForEscapeKey = 27;
    this.magicNumberForTabIndex = -1;

    // Bind the context with the events
    this.open = this.open.bind(this);
    this.negative = this.negative.bind(this);
    this.positive = this.positive.bind(this);
    this.checkEscapeKey = this.checkEscapeKey.bind(this);

    if (!this.isEverythingOk()) {
      return;
    }
    // Initialize modal
    this.init();
  }

  init() {
    this.bindButtons();
    addEvent(this.clickRegion, 'click', this.open);
  }

  bindButtons() {
    for (const closeButton of this.modalContents.querySelectorAll('.js-modal-close')) {
      addEvent(closeButton, 'click', this.negative);
    }
    for (const positiveButton of this.modalContents.querySelectorAll('.js-modal-positive')) {
      addEvent(positiveButton, 'click', this.positive);
    }
  }

  open() {
    this.createBackdrop();
    this.modalContents.classList.add('modal--is-open');
    document.body.setAttribute('aria-hidden', 'true');
    addEvent(document, 'keydown', this.checkEscapeKey);
    triggerEvent(this.modalContents, 'show.commonui.modal');
    this.isOpen = true;
  }

  close() {
    this.removeBackdrop();
    this.modalContents.classList.remove('modal--is-open');
    document.body.removeAttribute('aria-hidden', 'true');
    document.onkeydown = null;
    triggerEvent(this.modalContents, 'hide.commonui.modal');
    this.isOpen = false;
  }

  createBackdrop() {
    // Create the modal backdrop container
    this.modalBackdrop = document.createElement('div');
    this.modalBackdrop.classList.add('modal-backdrop');
    this.modalBackdrop.classList.add('modal-backdrop--open');
    this.modalBackdrop.setAttribute('tabindex', this.magicNumberForTabIndex);
    document.body.appendChild(this.modalBackdrop);
    this.modalBackdrop.focus();
  }

  removeBackdrop() {
    if (this.isOpen) {
      this.modalBackdrop.outerHTML = '';
    }
  }

  positive() {
    triggerEvent(this.modalContents, 'positive.commonui.modal');
    this.close();
  }

  negative() {
    triggerEvent(this.modalContents, 'negative.commonui.modal');
    this.close();
  }

  checkEscapeKey(evt) {
    if (evt && evt.keyCode === this.magicNumberForEscapeKey) {
      this.negative();
    }
  }

  destroy() {
    this.close();
    removeEvent(this.clickRegion, 'click', this.open);
  }

  /* eslint-disable no-console */
  isEverythingOk() {
    if (!this.modalContents) {
      console.warn('CommonUI - Modal - No modal contents found');
      return false;
    }
    return true;
  }
  /* eslint-enable no-console */
}

/**
 * creates a new modal instance
 * @param  {Object} config
 */
export default function initModal(config = {}) {
  const { selector = '.js-modal', clickElementSelector = '.js-modal__button' } = config;
  let modal = null;
  if (typeof selector === 'string') {
    modal = new Modal(
      document.querySelector(selector),
      document.querySelector(clickElementSelector)
    );
  }
  return modal;
}



// WEBPACK FOOTER //
// ./js/components/Modal.js